var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.001 8C25.881 8 8.00098 25.88 8.00098 48C8.00098 70.12 25.881 88 48.001 88C70.121 88 88.001 70.12 88.001 48C88.001 25.88 70.121 8 48.001 8ZM68.001 62.36L62.361 68L48.001 53.64L33.641 68L28.001 62.36L42.361 48L28.001 33.64L33.641 28L48.001 42.36L62.361 28L68.001 33.64L53.641 48L68.001 62.36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.1bc1cdcfeae6ee3cc0e2e711789cb6ca.svg";
export { ForwardRef as ReactComponent };